import { createContext, useContext } from "react";
import type { ComponentType } from "react";

export interface ToolUIProps {
  toolCallId: string;
  args: string;
  result?: string;
  isRunning: boolean;
}

const EMPTY_MAP = new Map<string, ComponentType<ToolUIProps>>();

const ToolUIContext = createContext<Map<string, ComponentType<ToolUIProps>>>(EMPTY_MAP);

export const ToolUIProvider = ToolUIContext.Provider;

export function useToolUIMap(): Map<string, ComponentType<ToolUIProps>> {
  return useContext(ToolUIContext);
}
